var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRazorpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30968 5.85123L4.47711 12.8489H0L0.907828 9.40634L6.30968 5.85123Z",
    fill: "#072654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3752 0.771667L7.19499 12.8489H5.01282L7.16115 4.66991L3.86816 6.83561L4.45459 4.68116L10.3752 0.771667Z",
    fill: "#3395FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazorpay);
export default __webpack_public_path__ + "static/media/Razorpay.1944ce9b2c32ae47e92134589ee5ba1f.svg";
export { ForwardRef as ReactComponent };